
import { config } from '@fortawesome/fontawesome-svg-core'
import '@fortawesome/fontawesome-svg-core/styles.css'
import "slick-carousel/slick/slick.css"
import "slick-carousel/slick/slick-theme.css"
import 'vanilla-cookieconsent/dist/cookieconsent.css'
import * as CookieConsent from 'vanilla-cookieconsent'
import frCookieConsent from './src/locales/fr/cookieconsent.json'
import enCookieConsent from './src/locales/en/cookieconsent.json'

// Umami config
const UMAMI_SRC = 'https://cloud.umami.is/script.js'
const UMAMI_WEBSITE_ID = '352f1ab3-4581-4836-8a3c-b2dfb657b429'

config.autoAddCss = false

const cookieConsentTranslations = {
  fr: frCookieConsent,
  en: enCookieConsent,
}

const loadUmami = () => {
  if (typeof window === 'undefined') return
  if (window.umami) return
  const existing = document.querySelector(`script[data-website-id="${UMAMI_WEBSITE_ID}"]`)
  if (existing) return

  CookieConsent.loadScript(UMAMI_SRC, {
    'data-website-id': UMAMI_WEBSITE_ID,
    async: 'true',
    defer: 'true',
  }).catch(() => {
    // Ignore loading errors; could log to console if needed
  })
}

const enableAnalyticsIfAllowed = (cookie = {}) => {
  const categories = cookie.categories || []
  if (categories.includes('analytics')) {
    loadUmami()
  }
}

// Fast locale redirect from "/" to "/fr/" or "/en/" to avoid blank first render
export const onClientEntry = () => {
  if (typeof window === 'undefined') return

  const path = window.location.pathname
  if (path === '/' || path === '/index.html') {
    const lang = (navigator.language || navigator.userLanguage || '').toLowerCase()
    const target = lang.startsWith('fr') ? '/fr/' : '/en/'
    if (path !== target) {
      window.location.replace(target)
      return
    }
  }

  const pathSegments = path.split('/').filter(Boolean)
  const currentLang = pathSegments[0] === 'en' ? 'en' : 'fr'

  CookieConsent.run({
    autoclear_cookies: true,
    page_scripts: true,
    categories: {
      necessary: {
        enabled: true,
        readOnly: true,
      },
      analytics: {
        enabled: false,
      },
    },
    language: {
      default: currentLang,
      translations: cookieConsentTranslations,
    },
    onConsent: ({ cookie }) => {
      enableAnalyticsIfAllowed(cookie)
    },
    onChange: ({ cookie }) => {
      enableAnalyticsIfAllowed(cookie)
    },
  })
    .then(() => {
      const cookie = CookieConsent.getCookie()
      enableAnalyticsIfAllowed(cookie)
    })
}
